/**
 * The two halves of TOTP enrolment (decision 48).
 *
 * Better Auth hands back an `otpauth://totp/...?secret=...` URI. That URI is
 * what a **QR code** encodes — but an authenticator app's "setup key" field
 * wants the **base32 secret on its own**, and rejects the URI as an illegal
 * character because `:`, `/` and `?` are not base32. Showing the right one in
 * the right place is the whole job of this file.
 */
export function totpSecretFrom(uri: string): string | null {
  try {
    return new URL(uri).searchParams.get("secret");
  } catch {
    // Not a URI at all — nothing to type in by hand.
    return null;
  }
}
